



















































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import api from "@/api";
import {showTagRE} from "@/utils/common"

@Component({
    name: "mtable",
    components: {}
})

export default class extends Vue {
    // @Prop() private userType !: ''

    showTagRE = showTagRE

    radio1 = '0'
    // 表格数据
    tableData = [];
    tableData2 = [];
    // 加载状态
    loading = false;
    loading2 = false;
    btnloading = false;
    // 总条数
    total = 0;
    total2 = 0;
    // 搜索条件
    search: any = {
        keyword: '',
        createTime: [],
        updateTime: [],
        status: '',
        pagination: {
            page: 0, //页码，从0开始
            pageSize: 20, //每页数量
        },
    };

    config = {}
     getConfig() {
        api.getJavaConfig().then((res) => {
            this.config = res;
        });
    }

    labelList = []
    labelTable() {
        api.post('J27605').then(res => {
            this.labelList = res.list
        })
    }

    toHY(row: any) {
        sessionStorage.setItem('kfId', row.id)
        this.$router.push({path: '/member/list'})
    }

    del(row: any) {
        this.$confirm('是否确认删除该客服人员?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            api.post('J27775', {id: row.id}).then(res => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.searchTable()
            })

        })
    }


    kfList = []
    selectKFList = [] // 存储选中的客服列表
    // 添加客服相关的搜索条件
    kfSearch: any = {
        keyword: '', // 添加keyword字段
        pagination: {
            page: 0, //页码，从0开始
            pageSize: 20, //每页数量
        },
    };
    kfTotal = 0
    addDialog = false
    addInfo: any = {}

    // 获取行的唯一标识
    getRowKey(row: any) {
        return row.userId
    }

    // 处理选中变化
    handleChange(val: any) {
        // 更新选中列表，保持引用不变
        this.selectKFList = val
    }

    // 搜索客服列表（保持选中状态）
    searchKfList() {
        // 重置页码
        this.kfSearch.pagination.page = 0
        this.loadKfList()
    }

    // 加载客服列表
    loadKfList() {
        api
            .post("J27773", this.kfSearch)
            .then((data) => {
                this.kfTotal = data.total;
                this.kfList = data.list;
   
                // 数据加载完成后，恢复选中状态
                this.$nextTick(() => {
                    if (this.selectKFList.length > 0 && this.$refs.table) {
                        const tableRef: any = this.$refs.table;
                        // 遍历当前列表，恢复选中状态
                        this.kfList.forEach((row: any) => {
                            const isSelected = this.selectKFList.some(
                                (selected: any) => selected.userId === row.userId
                            );
                            if (isSelected) {
                                tableRef.toggleRowSelection(row, true);
                            }
                        });
                    }
                });
            })
    }

    // 分页切换
    changePage(page: any) {
        this.kfSearch.pagination.page = page - 1
        this.loadKfList()
    }

    // 打开添加客服对话框
    add() {
        // 重置搜索条件和选中状态
        this.kfSearch.keyword = ''
        this.kfSearch.pagination.page = 0
        // 清空之前选中的数据（如果需要在关闭对话框后清空，可以保留）
        this.selectKFList = []
        this.loadKfList()
        this.labelTable()
        this.addDialog = true
    }

    // 确定添加客服
    sureAdd() {
        if (this.selectKFList.length === 0) {
            this.$message.warning('请至少选择一个客服')
            return
        }
     
        const userIds = this.selectKFList.map((item: any) => item.userId)
        
        api
            .post('J27774', {userIds})
            .then(res => {
                this.$message.success('添加成功')
                this.addDialog = false
                // 清空选中状态
                this.selectKFList = []
                // 刷新主表格
                this.searchTable();
            })
            .catch(err => {
                this.$message.error('添加失败')
            })
    }

    // 日志
    logDialog = false;
    logList = [];
    logTotal = 0;
    lookLogDialog = false
    listLoading = false

    cancleLog() {
        this.logDialog = false;
    }
    cancleLogLook() {
        this.lookLogDialog = false;
    }

    logSearch = {
        objectId: "",
        objectType: "customer_service",
        pagination: {
        page: 0, //页码，从0开始
        pageSize: 10, //每页数量
        },
    };
    logTable = [];

    toLog(row: any) {
        this.logSearch.objectId = row.id;
        api
            .post('J27756', this.logSearch)
            .then(res => {
                this.logDialog = true;
  this.logTable = res.list;
  this.logTotal = res.total;
            })
    }

    changeLog(page: any) {
        this.logSearch.pagination.page = page - 1;
        api.post("J27756", { ...this.logSearch }).then((res) => {
        // this.logDialog = true
        this.logTable = res.list;
        this.logTotal = res.total;
        });
    }

    row = {};
    logDetail = false;
    openDesc = false;
    handleCloseLogDialog() {
        this.logDialog = false;
    }
    toLogDetail(row: any) {
        this.logDetail = true;
        this.row = row;
    }
    CloseLogDetailDialog() {
        this.logDetail = false;
    }

    // 冻结状态
    changeStatus(rows: any) {
        let apiUrl = ''
        if(rows.status == 1) {
            apiUrl = 'J27776'
        } else {
            apiUrl = 'J27777'
        }
        api.post(apiUrl, {id: rows.id}).then(res => {
            this.$message.success('操作成功')
            this.searchTable()
        })
    }

    // 搜索 search:true 重置翻页
    searchTable(search = false) {
        this.loading = true;
        if (search) {
            this.search.pagination = {
                pageSize: 20,
                page: 0,
            };
        }
        api
            .post("J27772", this.search)
            .then((data) => {
                this.total = data.total;
                this.tableData = data.list;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    activated() {
        this.getConfig()
        this.searchTable();
    }
}
